'use client';

import { useHorizontalScroll } from '@/hooks/useHorizontalScroll';

import { EdgeFade } from '@/components/atoms/EdgeFade';

import BentoBanner, { type BentoBannerProps } from '@/blocks/BentoBanner';

import { LabeledIconCard, LabeledIconCardItem } from './LabeledIconCard';

export type LabeledIconCardsProps = {
  items: LabeledIconCardItem[];
  banner?: BentoBannerProps;
};

export function LabeledIconCards({ items, banner }: LabeledIconCardsProps) {
  const { viewportRef, fadeSides } = useHorizontalScroll(items.length);

  return (
    <div className='flex flex-col gap-5'>
      <EdgeFade tone='dark' sides={fadeSides} className='md:contents'>
        <div
          ref={viewportRef}
          className='-my-1 overflow-x-auto py-1 scrollbar-none md:my-0 md:overflow-visible md:py-0'
          role='region'
          aria-label='Labeled icon cards'
          tabIndex={0}
        >
          <ul className='flex gap-5 md:grid md:grid-cols-4 md:gap-x-5 md:gap-y-3 lg:grid-cols-5'>
            {items.map((item, index) => (
              <li key={`${item.title}-${index}`} className='shrink-0 md:shrink'>
                <LabeledIconCard item={item} />
              </li>
            ))}
          </ul>
        </div>
      </EdgeFade>
      {banner && <BentoBanner {...banner} />}
    </div>
  );
}
